import { api as generatedApi } from './generated';
import { updateCode } from './cache-updates';

export * from './generated';

// More info for invalidation rules at:
// - https://redux-toolkit.js.org/rtk-query/usage/automated-refetching
// - https://redux-toolkit.js.org/rtk-query/usage/manual-cache-updates
export const api = generatedApi.enhanceEndpoints({
  addTagTypes: ['Code', 'CodeList'],
  endpoints: {
    getV2QrCodes: {
      providesTags(result, error, arg) {
        const commonTags = ['Code' as const, 'CodeList' as const];
        const tags = (result || []).map(({ slug }) => ({
          type: 'Code' as const,
          id: slug,
        }));

        return [...tags, ...commonTags];
      },
    },
    getV2QrCodesBySlug: {
      providesTags(result, error, arg) {
        return [{ type: 'Code' as const, id: arg.slug }];
      },
    },
    postV2QrCodes: {
      invalidatesTags: ['CodeList'],
    },
    putV2QrCodesBySlug: {
      invalidatesTags(result, error, arg) {
        return [
          'CodeList',
          // Cache auto invalidation is disabled due pessimistic updates.
          //, { type: 'Code' as const, id: arg.slug }
        ];
      },
      // This is an pessimistic update to the cache.
      // Instead of invalidating the cache and refetching the data,
      // we manually update the cache with the new data.
      async onQueryStarted({ slug }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          updateCode(dispatch, slug, data);
        } catch {}
      },
    },
    deleteV2QrCodesBySlug: {
      invalidatesTags(result, error, arg) {
        // Do not invalidate the deleted QR code due RTK will
        // trigger a refetch of the deleted QR code.
        return [
          'CodeList',
          //, { type: 'Code' as const, id: arg.slug }
        ];
      },
    },
  },
});
